import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { containerStyles } from '../../styles/common';
import Footer from '../../Footer';
import { Flex } from '@radix-ui/themes';

const styles = stylex.create({
    container: {
        position: 'relative',
        padding: '3rem 0',
        width: '100%',
    },
    heading: {
        textAlign: 'center',
        fontSize: '3.5rem',
        marginBottom: '1.5rem',
        color: '#fff',
        textShadow: '0 2px 4px rgba(0,0,0,0.3)',
        fontWeight: 300,
        letterSpacing: '0.05em',
        fontFamily: "'Oswald', sans-serif",
    },
    content: {
        fontSize: '1.2rem',
        lineHeight: 1.6,
        color: 'rgba(255, 255, 255, 0.8)',
        maxWidth: '600px',
        textShadow: '0 1px 2px rgba(0,0,0,0.15)',
        marginBottom: '2rem',
        textAlign: 'center',
        fontFamily: "'Montserrat', sans-serif",
    },
});

export default function ArtistSection() {
    const { t } = useTranslation();

    return (
        <Flex justify="center" direction="column" {...stylex.props(styles.container)}>
            <h1 id="artistTitle" {...stylex.props(styles.heading)}>{t('site.title')}</h1>

            <div id="artistDescription" {...stylex.props(containerStyles.simpleContainer)}>
                <p {...stylex.props(styles.content)}>
                    {t('site.description')}
                </p>
            </div>
            <Footer />
        </Flex>
    );
} 